import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "feed-post-chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockChartTraderboard = _resolveComponent("StockChartTraderboard")!
  const _component_BarChart = _resolveComponent("BarChart")!
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCandlestick)
      ? (_openBlock(), _createBlock(_component_StockChartTraderboard, {
          key: 'tb-' + _ctx.postId,
          widget: _ctx.widgetData,
          showGrid: true
        }, null, 8, ["widget"]))
      : (_ctx.isBar)
        ? (_openBlock(), _createBlock(_component_BarChart, {
            key: 'bar-' + _ctx.postId,
            showGrid: true,
            showTitle: false,
            colorsArr: _ctx.chartColors,
            widget: _ctx.widgetData,
            isCreateView: false
          }, null, 8, ["colorsArr", "widget"]))
        : (_openBlock(), _createBlock(_component_LineChart, {
            key: 'line-' + _ctx.postId,
            showDuration: false,
            showDaysFormat: true,
            showGrid: true,
            showHeader: false,
            isDataIndirect: false,
            colorsArr: _ctx.chartColors,
            widget: _ctx.widgetData,
            isCreateView: false
          }, null, 8, ["colorsArr", "widget"]))
  ]))
}